/* QUANTUM STORE — VARIANT SELECTOR / QTM.SYS V1.0 */

const _vsI18n = JSON.parse(document.getElementById('qs-i18n')?.textContent || '{}');

class VariantSelector extends HTMLElement {
  connectedCallback() {
    this._variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this._selectedOptions = this._variants[0].options.slice();
    this.addEventListener('click', this._onButtonClick.bind(this));
  }

  _onButtonClick(e) {
    const btn = e.target.closest('.qs-size-btn');
    if (!btn || btn.disabled) return;

    const position = Number(btn.dataset.optionPosition) - 1;
    const value    = btn.dataset.optionValue;

    this._selectedOptions[position] = value;

    // Update aria-checked state
    this.querySelectorAll(`.qs-size-btn[data-option-position="${position + 1}"]`).forEach(b => {
      b.setAttribute('aria-checked', b.dataset.optionValue === value ? 'true' : 'false');
    });

    this._updateVariant();
  }

  _updateVariant() {
    const variant = this._variants.find(v =>
      v.options.every((opt, i) => opt === this._selectedOptions[i])
    );

    if (!variant) return;

    // Update hidden input
    const idInput = document.getElementById('qs-variant-id');
    if (idInput) idInput.value = variant.id;

    // Update price
    const priceEl = document.getElementById('qs-price');
    const _locale = _vsI18n.locale || 'pt-BR';
    if (priceEl) {
      const price = (variant.price / 100).toLocaleString(_locale, { style: 'currency', currency: 'BRL' });
      const cmpPrice = variant.compare_at_price && variant.compare_at_price > variant.price
        ? `<s style="font-size:20px;opacity:.5;margin-right:8px;">${(variant.compare_at_price / 100).toLocaleString(_locale, { style: 'currency', currency: 'BRL' })}</s>`
        : '';
      priceEl.innerHTML = cmpPrice + price;
    }

    // Update add to cart button
    const addBtn = document.getElementById('qs-add-to-cart');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      const labelEl = addBtn.querySelector('span:first-child');
      if (labelEl) {
        const price = (variant.price / 100).toLocaleString(_locale, { style: 'currency', currency: 'BRL' });
        const addLabel = _vsI18n.products?.add_to_cart || 'ADD TO CART';
        const soldOutLabel = _vsI18n.products?.sold_out || 'SOLD OUT';
        labelEl.textContent = variant.available
          ? `${addLabel} · ${price}`
          : soldOutLabel;
      }
      addBtn.dataset.defaultLabel = addBtn.querySelector('span:first-child')?.textContent;
    }

    // Update buy now button
    const buyNowBtn = document.getElementById('qs-buy-now');
    if (buyNowBtn) buyNowBtn.disabled = !variant.available;

    // Switch main image to variant's featured media
    if (variant.featured_media) {
      const thumbBtn = document.querySelector(`.qs-thumb-btn[data-media-id="${variant.featured_media.id}"]`);
      if (thumbBtn && typeof qsSwitchMainImage === 'function') {
        qsSwitchMainImage(thumbBtn.dataset.src, thumbBtn);
      }
    }

    // Update URL without reload
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }
}

customElements.define('variant-selector', VariantSelector);
